export const STORAGE_PREFIX = '@scout';
